<template>
    <div class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <Toast/>
        <div class="grid justify-content-center p-2 lg:p-0" style="min-width:80%">
            <div class="col-12 mt-5 xl:mt-0 text-center">
                <a href="/">
                    <img src="/images/contablus1.png" alt="Contablus logo" class="mb-5" style="width:200px;">
                </a>
            </div>
            <div class="col-12 xl:col-6 creds-container" style="border-radius:30px; padding:0.3rem; background-color: #f7ab47;">
                <div class="h-full w-full m-0 py-7 px-4" style="border-radius:27px; background-color: white;">
                    <div class="w-full md:w-10 mx-auto">
                        <!-- Invalid link state -->
                        <div v-if="invalidLink" class="text-center">
                            <i class="pi pi-times-circle" style="font-size: 3rem; color: #d32f2f;"></i>
                            <div class="text-900 text-2xl font-medium mt-4 mb-2">Enlace no válido o expirado</div>
                            <span class="text-600 font-medium line-height-3">
                                El enlace de recuperación no es válido o ya caducó. Solicita uno nuevo para continuar.
                            </span>
                            <div class="text-center mt-5">
                                <a class="font-medium no-underline cursor-pointer" style="color: #27285f" @click="goToForgot()">Solicitar un nuevo enlace</a>
                            </div>
                        </div>

                        <!-- Form state -->
                        <div v-else>
                            <div class="text-center mb-5">
                                <div class="text-900 text-2xl font-medium mb-2">Nueva contraseña</div>
                                <span class="text-600 font-medium">Ingresa y confirma tu nueva contraseña.</span>
                            </div>
                            <div class="field">
                                <label for="password" class="block text-900 text-xl font-medium mb-2">Nueva contraseña</label>
                                <Password id="password" v-model="password" placeholder="Nueva contraseña" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem"
                                    promptLabel="Ingresa una contraseña" weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte"></Password>
                            </div>
                            <div class="field">
                                <label for="confirm" class="block text-900 text-xl font-medium mb-2">Confirmar contraseña</label>
                                <Password id="confirm" v-model="confirm" placeholder="Confirmar contraseña" :feedback="false" :toggleMask="true" class="w-full mb-3" inputClass="w-full" inputStyle="padding:1rem" @keyup.enter="submit()"></Password>
                            </div>
                            <Button label="Restablecer contraseña" class="w-full p-3 text-xl" style="background: #27285f; border: 0px;" :loading="loading" @click="submit()"></Button>
                            <div class="text-center mt-4">
                                <a class="font-medium no-underline cursor-pointer" style="color: #27285f" @click="goToLogin()">Volver a iniciar sesión</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpRequest from '../service/httpRequest';

export default {
    data() {
        return {
            uid: null,
            token: null,
            password: '',
            confirm: '',
            loading: false,
            invalidLink: false,
        }
    },
    created() {
        this.uid = this.$route.query.uid || null;
        this.token = this.$route.query.token || null;
        if (!this.uid || !this.token) {
            this.invalidLink = true;
        }
    },
    methods: {
        async submit() {
            const error = this.checkForm();
            if (error !== null) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
                return;
            }

            this.loading = true;
            const response = await httpRequest.confirmPasswordReset(this.uid, this.token, this.password);
            this.loading = false;

            if (!response) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No pudimos procesar la solicitud. Intenta nuevamente.', life: 4000 });
                return;
            }

            if (response.status === 200) {
                this.$toast.add({ severity: 'success', summary: 'Listo', detail: 'Tu contraseña fue restablecida. Ya puedes iniciar sesión.', life: 4000 });
                setTimeout(() => this.$router.push({ name: 'login' }), 1500);
            } else if (response.status === 503) {
                // Token inválido o expirado
                this.invalidLink = true;
            } else if (response.status === 429) {
                // Demasiados intentos
                this.$toast.add({ severity: 'warn', summary: 'Demasiados intentos', detail: 'Has realizado demasiados intentos. Espera un momento e inténtalo de nuevo.', life: 5000 });
            } else if (response.status === 422) {
                // Contraseña no cumple los requisitos (mensaje desde el backend)
                this.$toast.add({ severity: 'error', summary: 'Contraseña no válida', detail: response.error || 'La contraseña no cumple los requisitos de seguridad.', life: 5000 });
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No pudimos restablecer la contraseña. Intenta nuevamente.', life: 4000 });
            }
        },
        checkForm() {
            if (!this.password || this.password === '') {
                return 'Por favor ingresa tu nueva contraseña';
            }
            if (this.password.length < 8) {
                return 'La contraseña debe tener al menos 8 caracteres';
            }
            if (this.password !== this.confirm) {
                return 'Las contraseñas no coinciden';
            }
            return null;
        },
        goToLogin() {
            this.$router.push({ name: 'login' });
        },
        goToForgot() {
            this.$router.push({ name: 'forgot-password' });
        },
    }
}
</script>

<style scoped>
.pi-eye {
    transform: scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform: scale(1.6);
    margin-right: 1rem;
}

@media screen and (max-width: 760px) {
    .creds-container {
        width: 90%;
    }
}
</style>
